import toast from "react-hot-toast";
import {Song} from "../components/view/spotipitan/types";
import {diacriticsMap} from "./diacritic-utils";
import {contains} from "jquery";
import {text} from "node:stream/consumers";

export function parseTime(time: number): string {
    var minutes = Math.floor(time / 60);
    var seconds = Math.floor(time - (minutes * 60));

    // Asegurarse de que los minutos y los segundos estén en formato de dos dígitos
    var secondsStr = String(seconds).padStart(2, '0');

    return `${minutes}:${secondsStr}`;
}

export function parseTimeToString(time: number): string {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);

    let timeString = "";
    if (hours > 0) timeString += `${hours}h `;
    timeString += `${minutes}min`;

    return timeString;
}

export function getDateString(date: Date): string {
    const now = new Date();
    const target = new Date(date);

    // Normalizamos las fechas a medianoche para comparar solo año/mes/día
    const normalize = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

    const today = normalize(now);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const targetDay = normalize(target);

    const options: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
    };
    const timeString = target.toLocaleTimeString('es-ES', options);

    if (targetDay.getTime() === today.getTime()) {
        return `today at ${timeString}`;
    } else if (targetDay.getTime() === tomorrow.getTime()) {
        return `tomorrow at ${timeString}`;
    } else {
        const fullOptions: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        };
        return target.toLocaleString('es-ES', fullOptions).replace(',', '');
    }
}


export function shuffleList<T>(list: T[]): T[] {
    const newList = [...list];
    for (let i = newList.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newList[i], newList[j]] = [newList[j], newList[i]];
    }
    return newList;
}

const handleCopyFallback = (text: string) => {
    const tempInput = document.createElement("input");
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    toast.success("Enlace copiado al portapapeles");
}

export const handleCopy = (text: string) => {
    if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.success("Enlace copiado al portapapeles");
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
                handleCopyFallback(text);
            });
    } else {
        handleCopyFallback(text);
    }
}

export const getQueryParams = (url: string): Record<string, string> => {
    const params = new URLSearchParams(url.split("?")[1]);
    const result: Record<string, string> = {};
    params.forEach((value, key) => {
        result[key.toLowerCase()] = value;
    });
    return result;
}

export const getParentByClass = (element: HTMLElement, className: string): HTMLElement | null => {
    let parent: HTMLElement | null = element;
    while (parent && !parent.classList.contains(className)) {
        parent = parent.parentElement;
    }
    return parent;
}


export const areSameSongs = (song1: Song, song2?: Song | null) => {
    return song1.id === song2?.id;
}


export function validateEmail(email: string) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export const filterList = <T> (list: T[], query: string, toString: (listItem: T) => string) => {
    const keywords = normalize(query).toLowerCase().split(" ").filter(word => word.length >= 1);

    if (!keywords.length) return list;

    const suggestsMatches = list.map(suggest => ({suggest, matches: checkContains(toString(suggest), keywords)}));

    return suggestsMatches
        .filter(suggest => suggest.matches > (keywords.length < 2 ? 0 : 0.3))
        .sort((a, b) => b.matches - a.matches)
        .map(suggest => suggest.suggest);
}

export const checkContains = (text: string, keywords: string[]) => {
    const textLower = normalize(text).toLowerCase();
    const textWords = textLower.split(" ");

    const contains = keywords
        .map(keyword => {
                if (keyword.length && textLower.includes(keyword)) {
                    const matchingWords = textWords.filter(word => word.includes(keyword));

                    const matchingWordsSimilarity = matchingWords.map(word => {
                        const wordLength = word.length;
                        const keywordLength = keyword.length;
                        return {similarity: keywordLength / wordLength, weight: keyword.length}
                    });

                    return matchingWordsSimilarity.sort((a, b) => b.similarity - a.similarity)[0];
                } else {
                    return {
                        similarity: 0,
                        weight: keyword.length
                    };
                }
            }
        )
    ;

    const totalWeight = contains.reduce((acc, val) => acc + val.weight, 0);

    const totalPoints = contains.reduce((acc, val) =>
        acc + (val.similarity * val.weight / totalWeight), 0);

    return totalPoints;
}

// delete emojis, special characters and accents, mantain spaces
export const normalize = (str: string) => {
    return removeDiacritics(str).replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s+/g, ' ').trim().toLowerCase();
}

function removeDiacritics(str: string) {
    return str.replace(/[^\u0000-\u007E]/g, function (a) {
        return diacriticsMap[a] || a;
    });
}